import { INVESTOR_SLIDES } from "./constants";

export type ViewerType = "slides" | "pdf" | "markdown";

export interface Document {
  id: string;
  title: string;
  category: string;
  date: string;
  version: string;
  viewerType: ViewerType;
  description: string;
}

export const DOCUMENTS: Document[] = [
  {
    id: "CX-001-A",
    title: "COSX Company Introduction",
    category: "Overview",
    date: "2026-03-26",
    version: "A",
    viewerType: "slides",
    description: "6-slide company introduction deck for BD use alongside the legal sales deck.",
  },
  {
    id: "CX-002-A",
    title: "Investor Pitch Deck",
    category: "Pitch",
    date: "2026-03-15",
    version: "A",
    viewerType: "slides",
    description: `${INVESTOR_SLIDES.length}-slide investor presentation covering opportunity, solution, business model, and roadmap.`,
  },
  {
    id: "CX-002-B",
    title: "COSX Pitch Deck v2",
    category: "Pitch",
    date: "2026-03-30",
    version: "B",
    viewerType: "slides",
    description: "15-slide investor pitch deck v2 with data flywheel and harness engineering narrative.",
  },
  {
    id: "CX-002-C",
    title: "COSX Pitch Deck v3",
    category: "Pitch",
    date: "2026-04-28",
    version: "C",
    viewerType: "slides",
    description: "14-slide seed pitch deck — AI back-office for professional services. Capability → Proof → Expansion → Structure → Vision → Ask.",
  },
  {
    id: "CX-003-A",
    title: "COSX Legal: AI Paralegal Agents",
    category: "Sales",
    date: "2026-03-26",
    version: "A",
    viewerType: "slides",
    description: "10-slide sales deck for law firm conversations covering AI paralegal agents, capabilities, and security.",
  },
  {
    id: "CX-004-A",
    title: "Technical Architecture",
    category: "Technical",
    date: "2026-03-15",
    version: "A",
    viewerType: "pdf",
    description: "Platform architecture, infrastructure, and security overview.",
  },
];

export function getDocument(docId: string): Document | undefined {
  return DOCUMENTS.find((d) => d.id === docId);
}
